export default {
  sidebar: {
    dashboard: "Tableau de bord",
    collections: "Encaissements",
    payments: "Paiements",
    transactions: "Transactions",
    collectedPayments: "Paiements collectés",
    transfers: "Transferts",
    pendingTransfers: "Transferts en attente de validation",
    linksToValidateLevel1: "Liens à valider (niveau 1)",
    linksToValidateLevel2: "Liens à valider (niveau 2)",
    contacts: "Contacts",
    crm: "CRM",
    organizations: "Organisations",
    users: "Utilisateurs",
    myAccounts: "Mes comptes",
    finances: "Finances",
    refunds: "Réversements",
    reloads: "Rechargements",
    business: "Business",
    balance: "Balance",
    operationsStatement: "Relevé d'opérations",
    settings: "Paramètres",
    countries: "Pays",
    feeTypes: "Type de frais",
    fees: "Frais",
    providers: "Entreprise",
    operators: "Opérateur",
    permissions: "Permissions",
    actions: "Actions",
    accountConfiguration: "Configuration du compte",
    settingsConfiguration: "Configuration des paramètres",
    logout: "Se déconnecter"
  },
  auth: {
    login: "Connexion",
    logout: "Déconnexion",
    "accountType": "Type de compte",
    "selectType": "Sélectionnez un type de compte",
    "loggedOut": "Vous êtes déconnecté",
    "seeYouSoon": "À très bientôt nous sommes impatient de vous revoir",
    "loginNow": "Connectez vous maintenant",
    "loginToAccount": "Connectez-vous à votre compte!",
    "emailAddress": "Adresse email",
    "password": "Mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "noAccount": "Vous n'avez pas de compte ?",
    "createAccount": "Créer un compte",
    "resetInstructions": "Entrez votre adresse e-mail ci-dessous et nous vous enverrons le lien de réinitialisation",
    "send": "Envoyer",
    "backToLogin": "Revenir pour se connecter",
    "createYourAccount": "Créez votre compte",
    "companyName": "Raison sociale",
    "contact": "Contact",
    "bankName": "Nom de votre banque",
    "rib": "Votre RIB",
    "cryptoAccount": "Compte de Criptomonaie",
    "confirmPassword": "Confirmation du mot de passe",
    "signUpNow": "S'inscrire maintenant",
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "loginHere": "Connecte-toi ici",
    "allRightsReserved": "Tous droits réservés à",
    "theAccountsOf": "Les comptes de",
    "reloadsList": "Liste des rechargements",
    "myBusinesses": "Mes business"
  },
  contacts: {
    "addContact": "Ajouter contact",
    "massImport": "import en masse",
    "code": "Code",
    "search": "Recherche",
    "organization": "Organisation",
    "firstName": "Nom",
    "lastName": "Prénom(s)",
    "phoneNumber": "numéro de téléphone",
    "transfer": "Transfert",
    "delete": "Supprimer",
    "edit": "Modifier",
    "alert": "Alert",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact",
    "no": "Non",
    "yes": "Oui",
    "addContactTitle": "Ajouter un contact",
    "editContact": "Modifier un contact",
    "phonePlaceholder": "ex: 0720230120",
    "firstNamePlaceholder": "ex: BOLI",
    "lastNamePlaceholder": "ex: FRANK",
    "save": "Enregister",
    "transferMoney": "Transferer de l'argent",
    "balance": "SOLDE",
    "operators": "Opérateurs",
    "select": "Selectionnez...",
    "amount": "Montant",
    "amountPlaceholder": "ex: 2000",
    "business": "Business",
    "transferBtn": "Transférer",
    "importContacts": "Importer des contacts",
    "phoneSizeError": "Erreur sur la taille d'un numéro de téléphone :",
    "phoneFormatError": "Erreur sur le format d'un numéro de téléphone :",
    "duplicatePhoneError": "Numéro de téléphone en doublon :",
    "proceedImport": "Vous pouvez procéder à l'import.",
    "correctErrors": "Corrigez ces erreurs avant de continuer.",
    "download": "Télécharger",
    "templateFile": "Le fichier modèle",
    "country": "Pays",
    "selectCountry": "Selectionnez le pays",
    "senegal": "Sénégal",
    "ivoryCoast": "Côte d'Ivoire",
    "uploadFile": "Uploader le fichier",
    "refresh": "Rafraichir",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  "tokens": {
    "title": "Gestion des Tokens",
    "search": "Rechercher un token...",
    "refresh": "Actualiser",
    "code": "Code",
    "user": "Utilisateur",
    "email": "Email",
    "type": "Type",
    "deviceId": "ID Appareil",
    "userAgent": "Navigateur",
    "ipAddress": "Adresse IP",
    "createdAt": "Créé le",
    "expiresAt": "Expire le",
    "status": "Statut",
    "active": "Actif",
    "revoked": "Révoqué",
    "revoke": "Révoquer",
    "revokeConfirm": "Confirmation de révocation",
    "revokeMessage": "Êtes-vous sûr de vouloir révoquer ce token ? Cette action est irréversible.",
    "token": "Token",
    "cancel": "Annuler",
    "revokeError": "Erreur lors de la révocation du token",
    "showing": "Affichage de",
    "outOf": "sur",
    "results": "résultats"
  },
  organizations: {
    "createClient": "Créer un client",
    "createOrg": "Créer une organisation",
    "customerName": "Customer Name",
    "bank": "Banque",
    "search": "Rechercher...",
    "rib": "RIB",
    "cryptocurrency": "Cryptomonnaie",
    "email": "EMAIL",
    "status": "STATUS",
    "active": "Actif",
    "inactive": "Inactif",
    "users": "Utilisateurs",
    "accounts": "Comptes",
    "fees": "Frais",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "edit": "Modifier",
    "maxPayoutAmount": "Montant max de retrait",
    "maxPayoutAmountPlaceholder": "Entrez le montant maximum",
    "payoutValidationDelay": "Délai de validation retrait",
    "payoutValidationDelayPlaceholder": "Entrez le délai en minutes",
    "createTitle": "Creation d'un client",
    "editTitle": "Modification une organisation",
    "companyName": "Raison sociale",
    "companyNamePlaceholder": "I-MONEY AFRICA",
    "phone": "Téléphone",
    "phonePlaceholder": "ex: 0500457801",
    "cryptoAccount": "compte de Criptomonaie",
    "cryptoPlaceholder": "ex: votre email",
    "bankPlaceholder": "ex: ECOBANK",
    "ribPlaceholder": "",
    "requiresValidation": "Nécessite une validation",
    "no": "Non",
    "yes": "Oui",
    "type": "Type",
    "legal": "Légale",
    "person": "Personne",
    "description": "Description",
    "descriptionPlaceholder": "Saisir la description de l'entreprise ici",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  balances: {
    "code": "Code",
    "selectBalanceType": "Sélectionner un type de balance",
    "country": "Pays",
    "name": "Nom",
    "active": "Actif",
    "inactive": "Inactive",
    "balanceType": "Type de solde",
    "selectOperator": "Sélectionner un opérateur",
    "selectCountry": "Sélectionner un pays",
    "operator": "Opérateur",
    "balanceLimit": "Limite du solde",
    "balanceLimitPlaceholder": "Laisser vide si aucune limite",
    "type": "Type",
    "search": "Rechercher...",
    "status": "Status",
    "balance": "Solde",
    "transfer": "Transfert",
    "delete": "Supprimer",
    "edit": "Modifier",
    "alert": "Alert",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact",
    "no": "Non",
    "yes": "Oui",
    "addBalance": "Ajouter un balance",
    "editBalance": "Modifier un balance",
    "balanceName": "Nom du balance",
    "balanceNamePlaceholder": "ex: I-MONEY",
    "description": "Description",
    "descriptionPlaceholder": "ex: saisissez la description ici",
    "maxAmount": "Montant maximum",
    "maxAmountPlaceholder": "ex: 2 000 000",
    "requiresValidation": "Nécessite une validation",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  export: {
    "excel": "Excel",
    "paymentLink": "Lien de paiement",
    "transferBalance": "Solde transfert",
    "collectBalance": "Solde collecte",
    "operationsStatement": "Relévé d'opérations",
    "period": "Période du",
    "to": "au",
    "transactionCode": "CODE TRANSACTION",
    "operation": "OPERATION",
    "fees": "Frais",
    "amount": "MONTANT",
    "date": "DATE",
    "status": "STATUT",
    "success": "SUCCÈS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "exportFinancialData": "Exportation des données financières",
    "clients": "Clients",
    "select": "Selectionnez...",
    "detail": "Détail",
    "startDate": "Date debut",
    "endDate": "Date fin",
    "exportBtn": "Exporter"
  },
  countries: {
    "createCountry": "Créer un pays",
    "code": "Code",
    "countryCode": "Code pays",
    "search": "Rechercher...",
    "name": "Nom",
    "indicative": "Indicatif",
    "currency": "Dévise",
    "status": "STATUS",
    "active": "Actif",
    "inactive": "Inactif",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "country": "Pays",
    "countryCodePlaceholder": "CI",
    "namePlaceholder": "Cote d'Ivoire",
    "indicativePlaceholder": "ex: 225",
    "currencyPlaceholder": "ex: XOF",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  feeTypes: {
    "createFeeType": "Créer un type de frais",
    "code": "Code",
    "name": "Nom",
    "description": "Description",
    "status": "Status",
    "active": "Actif",
    "inactive": "Inactif",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "feeType": "Type de frais",
    "namePlaceholder": "Cote d'Ivoire",
    "descriptionPlaceholder": "Saisir la description de l'entreprise ici",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  providers: {
    "addProvider": "Ajouter un providor",
    "editProvider": "Modifier un providor",
    "code": "Code",
    "name": "Nom",
    "description": "Description",
    "type": "Type",
    "edit": "Modifier",
    "alert": "Alert",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact",
    "no": "Non",
    "yes": "Oui",
    "providerName": "Nom du providor",
    "providerNamePlaceholder": "ex: I-MONEY",
    "descriptionPlaceholder": "ex: saisissez la description ici",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  operators: {
    "addOperator": "Ajouter un opérateur",
    "editOperator": "Modifier un opérateur",
    "code": "Code",
    "operator": "Operateur",
    "mno": "MNO",
    "searchPlaceholder": "Rechercher un opérateur...",
    "provider": "Entreprise",
    "operationType": "Type d'opération",
    "paymentMethod": "Méthode de paiement",
    "country": "Pays",
    "countryCode": "Code Pays",
    "phoneCode": "Indice Téléphonique",
    "phoneMask": "Masque Téléphonique",
    "activationDelay": "Délais d'activation",
    "description": "Description",
    "status": "Status",
    "active": "Actif",
    "inactive": "Inactif",
    "payin": "PAYIN",
    "payout": "PAYOUT",
    "payinPayout": "PAYIN-PAYOUT",
    "switch": "Switch",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "edit": "Modifier",
    "name": "Nom",
    "namePlaceholder": "Nom ...",
    "mnoPlaceholder": "MNO ...",
    "select": "Selectionnez...",
    "paymentMethodPlaceholder": "Methode de paiement ...",
    "phoneCodePlaceholder": "Indice ...",
    "phoneMaskPlaceholder": "10",
    "descriptionPlaceholder": "description...",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats",
    "isOtpRequired": "OTP Requis",
    "otpInputMask": "Masque OTP",
    "otpInputMaskPlaceholder": "Entrez le masque OTP"
  },
  permissions: {
    "addPermission": "Ajouter une permission",
    "editPermission": "Modifier une permission",
    "code": "Code",
    "searchPlaceholder": "Rechercher une permission...",
    "permission": "Permission",
    "description": "Description",
    "viewActions": "Voir actions",
    "namePlaceholder": "Nom ...",
    "descriptionPlaceholder": "Description ...",
    "actions": "Actions",
    "select": "Selectionnez...",
    "save": "Enregister",
    "edit": "Modifier",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  permissionsAdd: {
    "permission": "Permission",
    "namePlaceholder": "Nom ...",
    "description": "Description",
    "descriptionPlaceholder": "Description ...",
    "actions": "Actions",
    "select": "Selectionnez...",
    "save": "Enregister",
    "edit": "Modifier"
  },
  actions: {
    "code": "Code",
    "action": "Action",
    "description": "Description",
    "addAction": "Ajouter une action",
    "editAction": "Modifier une action",
    "name": "Nom",
    "namePlaceholder": "Nom ...",
    "mno": "MNO",
    "mnoPlaceholder": "MNO ...",
    "status": "Status",
    "select": "Selectionnez...",
    "paymentMethod": "Methode de paiement",
    "paymentMethodPlaceholder": "Methode de paiement ...",
    "phoneCode": "Indice Telephonique",
    "phoneCodePlaceholder": "Indice ...",
    "operationType": "Type d'operation",
    "payin": "PAYIN",
    "payout": "PAYOUT",
    "payinPayout": "PAYIN-PAYOUT",
    "provider": "Entreprise",
    "activationDelay": "Delais d'activation",
    "active": "ACTIF",
    "inactive": "INACTIF",
    "phoneMask": "Masque telephonique",
    "phoneMaskPlaceholder": "10",
    "country": "Pays",
    "descriptionPlaceholder": "description...",
    "save": "Enregister",
    "edit": "Modifier",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  dashboard: {
    "totalTransactionPerMonth": "Montant total transaction par mois",
    "weeklyCollections": "COLLECTES HEBDOMADAIRE"
  },
  header: {
    transferBalance: "SOLDE TRANSFERT",
    collectBalance: "SOLDE ENCAISSÉ",
    availableBalance: "SOLDE DISPONIBLE",
    mainBalance: "Solde principal",
    otherBalances: "Autres soldes"
  },
  "merchants": {
    "create": "Créer",
    "search_organization": "Rechercher une organisation...",
    "organization": "Organisation",
    "main_account": "Compte principal",
    "main_balance": "Solde principal(XOF)",
    "other_accounts": "Autres comptes",
    "status": "Statut",
    "active": "Actif",
    "inactive": "Inactif",
    "no_organization": "Aucune organisation trouvée.",
    "showing": "{count} organisation(s) affichée(s) sur",
    "view": "Voir",
    "edit": "Modifier",
    "change_status": "Changer statut",
    "create_merchant_accounts": "Créer les comptes marchands",
    "cancel": "Annuler",
    "other_accounts_title": "Autres comptes",
    "type": "Type",
    "name": "Nom",
    "balance": "Solde",
    "blocked_balance": "Solde bloqué",
    "track_balance": "Suivi solde",
    "created_at": "Créé le",
    "close": "Fermer",
    "organization_info": "Informations de l'organisation",
    "code": "Code",
    "description": "Description",
    "organization_status": "Statut organisation",
    "email": "Email",
    "contact": "Contact",
    "bank_domiciliation": "Domiciliation bancaire",
    "rib": "RIB",
    "created_on": "Créée le",
    "organization_accounts": "Comptes de l'organisation",
    "edit_account": "Modifier un compte",
    "account_to_edit": "Compte à modifier",
    "select_account": "Sélectionner un compte",
    "account_type": "Type de compte",
    "save": "Enregistrer",
    "change_status_title": "Modifier le statut",
    "account": "Compte",
    "validate": "Valider",
    "yes": "Oui",
    "no": "Non",
    "loading": "Chargement...",
    "load_more_organizations": "Charger plus d'organisations",
    "please_select_organization": "Veuillez sélectionner une organisation.",
    "please_select_account": "Veuillez sélectionner un compte.",
    "merchant_accounts_created": "Compte(s) marchand(s) créé(s)",
    "merchant_account_updated": "Compte marchand mis à jour",
    "status_updated": "Statut mis à jour",
    "error_loading_organizations": "Erreur lors du chargement des organisations",
    "error_occurred": "Une erreur est survenue.",
    "view_other_accounts": "Voir les {count} autres comptes"
  },
  errors: {
    "unexpectedError": "une erreur inattendue est apparue"
  },
  "doubleEntries": {
      "title": "Doubles entrées",
      "detail_general": "Informations générales",
      "detail_ledger_entries": "Mouvements comptables",
      "detail_transaction": "Transaction associée",
      "detail_topup": "Rechargement",
      "detail_repayment": "Remboursement",
      "detail_integrity": "Intégrité",
      "integrity_hash": "Hash d'intégrité",
      "previous_hash": "Hash précédent",
      "merchant_account_type": "Type de compte marchand",
      "provider_balance_type": "Type de solde fournisseur",
      "error_loading_detail": "Impossible de charger le détail de l'écriture.",
      "retry": "Réessayer",
      "tx_code": "Code transaction",
      "tx_payout_id": "ID payout",
      "tx_checkout_id": "ID checkout",
      "tx_int_bulk_id": "ID bulk",
      "tx_int_operator_bulk_id": "ID bulk opérateur",
      "tx_bank_transfert_id": "ID virement bancaire",
      "tx_transaction_type": "Type de transaction",
      "tx_payout_type": "Type de payout",
      "tx_bank_transfert_type": "Type de virement bancaire",
      "tx_amount": "Montant",
      "tx_bulk_total_amount": "Montant total du bulk",
      "tx_total_fees": "Frais totaux",
      "tx_imoney_fees": "Frais iMoney",
    "tx_operator_fees": "Frais opérateur",
      "total_entries": "{count} écritures",
      "refresh": "Actualiser",
      "loading": "Chargement...",
      "search_placeholder": "Rechercher dans la description",
      "filters": "Filtres",
      "filters_title": "Filtrer les écritures",
      "apply": "Appliquer",
      "reset": "Réinitialiser",
      "cancel": "Annuler",
      "close": "Fermer",
      "copy": "Copier",
      "all": "Tous",
      "actions": "Actions",
      "view_detail": "Voir le détail",
      "detail_title": "Détail de l'écriture",
      "date": "Date",
      "reference": "Référence",
      "external_reference": "Référence externe",
      "description": "Description",
      "debit": "Débit",
      "credit": "Crédit",
      "amount": "Montant",
      "exact_amount": "Montant exact",
      "min_amount": "Montant minimum",
      "max_amount": "Montant maximum",
      "currency": "Devise",
      "entry_type": "Entrée",
      "entity": "Entité",
      "entity_type": "Type d'entité",
      "entity_code": "Code de l'entité",
      "status": "AdjustmentType",
      "other_entries": "Autres écritures",
      "other_entries_title": "Autres écritures de l'entité",
      "view_other_entries": "Voir les {count} autres écritures",
      "date_from": "Date de début",
      "date_to": "Date de fin",
      "order": "Ordre",
      "order_desc": "Récent",
      "order_asc": "Ancien",
      "per_page": "Par page",
      "real": "Réelle",
      "virtual": "Virtuelle",
      "normal": "Normal",
      "no_entries": "Aucune écriture trouvée",
      "showing": "Affichage de {count} sur",
      "copy_reference": "Cliquer pour copier la référence",
      "copied": "Copié",
      "error_loading": "Erreur lors du chargement des écritures",
      "error_amount_range": "Le montant minimum doit être inférieur au montant maximum",
      "error_date_range": "La date de début doit être antérieure à la date de fin",
      "error_occurred": "Une erreur est survenue"
    },
  breadCrumb: {
    transTitleP: "Paiements collectés",
    "doubleentrylist":"Liste des doubles écritures",
    marchantAccountListe: "Liste des comptes marchands",
    transTitleD: "Encaissements",
    "title": "Gestion des Tokens",
    "collectedPaymentsBy": "Paiements collectés par",
    "leadDetails": "Lead Details",
    "clientList": "Liste de clients",
    "organisationlist": "Liste des organisations",
    "myDirectory": "Mon repertoire",
    "contactsList": "Contacts List",
    "multipleTransfer": "Transfert multiple",
    "pendingTransfersList": "Liste des transferts en attente de validation",
    "moneyTransfers": "Envois d'argent",
    "users": "Les utilisateurs",
    "level1ValidationLinks": "Liste des liens de validation niveau 1",
    "level2ValidationLinks": "Liste des liens de validation niveau 2",
    "refundsList": "Liste des réversements",
    "settingsConfiguration": "Configuration des parametres",
    "accountConfiguration": "Configuration du compte",
    "actionsList": "Liste des actions",
    "permissionsList": "Liste des permissions",
    "operatorsList": "Liste des opérateurs",
    "provider": "Entreprise",
    "feesList": "Liste des frais",
    "countriesList": "Liste des pays",
    "providerBalances": "Les soldes fournisseur",
    "myAccount": "Mon compte",
    "changeMyPassword": "Modifier mon mot de passe",
    "privacyPolicy": "Politique de confidentialité",
    "socialLinks": "Liens sociaux",
    "feeTypesList": "Liste type de frais",
  },
  transactions: {
    "export": "Export",
    "link": "Lien",
    "payment": " de paiement",
    "collection": " d'encaissement",
    "code": "CODE TRANSACTION",
    "operator": "OPERATEUR",
    "phone": "TELEPHONE",
    "amount": "MONTANT",
    "date": "DATE",
    "status": "STATUT",
    "processingDate": "Date de traitement",
    "success": "SUCCESS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "view": "Voir",
    "description":"DESCRIPTION",
    "receipt": "Reçu",
    "claim": "Réclamation",
    "exportExcel": "Exportation des transactions au format excel",
    "advancedSearch": "Recherche avancé",
    "clients": "Clients",
    "select": "Selectionnez...",
    "country": "Pays",
    "senegal": "Sénégal",
    "ivoryCoast": "Côte d'Ivoire",
    "operators": "Opérateurs",
    "statuses": "Statuts",
    "startDate": "Date debut",
    "endDate": "Date fin",
    "category": "Catégorie",
    "subCategory": "Sous-catégorie",
    "selectSubCategory": "Selectionnez une sous-catégorie",
    "phoneNumber": "Numéro de téléphone",
    "transactionDetails": "Details transaction",
    "transactionCode": "code transaction",
    "operatorReference": "Référence opérateur",
    "paymentLink": "Lien de paiement",
    "refresh": "Rafraichir",
    "generatePaymentLink": "Générer lien de paiement",
    "paymentQRCode": "QR Code de paiement",
    "scanToPay": "Scannez pour payer",
    "close": "Fermer",
    "download": "Télécharger",
    "transactionReceipt": "REÇU DE TRANSACTION",
    "amountLabel": "MONTANT......................................",
    "statusLabel": "STATUT...........................................",
    "beneficiary": "BENEFICIAIRE",
    "thankYou": "MERCI POUR LA CONFIANCE !",
    "showing": "Affichage de",
    "outOf": "sur",
    "results": "résultats",
    "editionDate": "DATE D'EDITION",
    "listTitle": "LISTE DES TRANSACTIONS",
    "period": "Période du",
    "to": "au",
    "excel": "Excel",
    "pdf": "Pdf",
    "showQRCode": "Afficher le QR code",
    "advancedDetails": "Informations avancées",
    "payoutId": "ID Payout",
    "bulkId": "ID Bulk",
    "technicalStatus": "Statut technique",
    "validationStatus": "Statut de validation",
    "statusCode": "Code statut",
    "operationType": "Type d'opération",
    "payin": "Encaissement",
    "payout": "Décaissement",
    "currency": "Devise",
    "countryCode": "Code pays",
    "imoneyFees": "Frais i-Money",
    "operatorFees": "Frais opérateur",
    "initiatedByUser": "Initié par",
    "businessLabel": "Business",
    "clientReference": "Référence client",
    "clientId": "ID client",
    "descriptionLabel": "Description",
    "handlingDate": "Date de traitement",
    "finalStateDate": "Date de statut final",
    "checkingDate": "Date de vérification",
    "apiVersion": "Version API",
    "errorMessage": "Message d'erreur"
  },
  transfers: {
    "export": "Export",
    "paymentLink": "Lien de paiement",
    "code": "CODE TRANSACTION",
    "noResultForExport": "Aucune transaction trouvée pour ces critères, l'export est impossible.",
    "beneficiary": "BENEFICIAIRE",
    "description": "DESCRIPTION",
    "operator": "OPERATEUR",
    "phone": "TELEPHONE",
    "amount": "MONTANT",
    "date": "DATE",
    "status": "STATUT",
    "validation": "VALIDATION",
    "success": "SUCCESS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "initiated": "INITIÉ",
    "scheduled": "PLANIFIÉ",
    "draft": "DRAFT",
    "validated": "VALIDÉ",
    "rejected": "REJETÉ",
    "level1": "Niveau 1",
    "level2": "Niveau 2",
    "view": "Voir",
    "downloadReceipt": "Télécharger le reçu",
    "copyLink": "Copier le lien",
    "claim": "Réclamation",
    "multipleSend": "Envoi multiple",
    "singleSend": "Envoi simple",
    "sendMoney": "Envoi d'argent",
    "balance": "SOLDE",
    "operators": "Opérateurs",
    "select": "Selectionnez...",
    "clients": "Clients",
    "category": "Catégorie",
    "subCategory": "Sous-catégorie",
    "selectSubCategory": "Selectionnez une sous-catégorie",
    "phoneNumber": "Numéro de téléphone",
    "descriptionPlaceholder": "Description",
    "send": "Envoyer",
    "exportTransactions": "Exportation des transactions",
    "advancedSearch": "Recherche avancé",
    "country": "Pays",
    "senegal": "Sénégal",
    "ivoryCoast": "Côte d'Ivoire",
    "statuses": "Statuts",
    "startDate": "Date debut",
    "endDate": "Date fin",
    "transactionDetails": "Details transaction",
    "transactionCode": "code transaction",
    "operatorReference": "Reférence opérateur",
    "refresh": "Rafraichir",
    "generatePaymentLink": "Générer lien de paiement",
    "validationType": "Type de validation",
    "simple": "SIMPLE",
    "double": "DOUBLE",
    "link": "Lien",
    "transactionReceipt": "REÇU DE TRANSACTION",
    "amountLabel": "MONTANT......................................",
    "statusLabel": "STATUT...........................................",
    "thankYou": "MERCI POUR LA CONFIANCE !",
    "showing": "Affichage de",
    "outOf": "sur",
    "results": "resultats",
    "editionDate": "Date d'édition le",
    "listTitle": "Liste des transactions",
    "period": "Période du",
    "to": "au",
    "excel": "Excel",
    "pdf": "Pdf"
  },

  validation: {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "search": "Rechercher...",
    "code": "CODE TRANSACTION",
    "beneficiary": "BENEFICIAIRE",
    "operator": "OPERATEUR",
    "phone": "TELEPHONE",
    "amount": "MONTANT",
    "date": "DATE",
    "status": "STATUT",
    "success": "SUCCESS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "initiated": "INITIÉ",
    "scheduled": "PLANIFIÉ",
    "alert": "Alert",
    "no": "Non",
    "yes": "Oui"
  },


  linkValidation: {
    "code": "CODE TRANSACTION",
    "beneficiary": "BENEFICIAIRE",
    "operator": "OPERATEUR",
    "phone": "TELEPHONE",
    "amount": "MONTANT",
    "expirationDate": "DATE D'EXPIRATION",
    "date": "DATE",
    "status": "STATUT",
    "actions": "ACTIONS",
    "success": "SUCCESS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "initiated": "INITIÉ",
    "scheduled": "PLANIFIÉ",
    "alert": "Alert",
    "no": "Non",
    "validationStatus": "Statut de validation",
    "paymentStatus": "Statut de paiement",
    "draft": "Brouillon",
    "validated": "Validé",
    "rejected": "Rejeté",
    "expired": "Expiré",
    "unknown": "Inconnu",
    "noAction": "Aucune action disponible",
    "yes": "Oui",
    "listTitle": "Liste des transactions",
    "transactionDetails": "Details transaction",
    "transactionCode": "code transaction"
  },
  linkValidationLevel2: {
    "code": "CODE TRANSACTION",
    "beneficiary": "BENEFICIAIRE",
    "operator": "OPERATEUR",
    "phone": "TELEPHONE",
    "amount": "MONTANT",
    "date": "DATE",
    "status": "STATUT",
    "actions": "ACTIONS",
    "success": "SUCCESS",
    "failed": "ECHEC",
    "processing": "EN COURS",
    "pending": "EN ATTENTE",
    "initiated": "INITIÉ",
    "scheduled": "PLANIFIÉ",
    "alert": "Alert",
    "no": "Non",
    "yes": "Oui",
    "listTitle": "Liste des transactions",
    "transactionDetails": "Details transaction",
    "transactionCode": "code transaction"
  },
  generalConfig: {
    "notificationUrlConfig": "Configuration de l'url de notification",
    "url": "Url",
    "notificationUrlConfigHint": "Recevez vos notifications de transactions sur cette URL.",
    "logoConfigHint": "Ce logo est utilisé sur vos documents et votre espace.",
    "logoSizeHint": "Taille maximum : {size} ko",
    "transactionValidationHint": "Exigez une validation manuelle avant traitement des paiements sortants.",
    "copy": "Copier",
    "urlPlaceholder": "entrez l'url de notification ici",
    "generateSecretKey": "Générer votre secret key",
    "saveUrl": "Enregistrer l'url",
    "logoConfig": "Configuration du logo",
    "logo": "Logo",
    "saveLogo": "Enregistrer le logo",
    "transactionValidation": "La validation des transactions",
    "validateTransactions": "Valider les transactions",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "linkValidityDuration": "Durée de validité d'un lien (en minute)",
    "durationPlaceholder": "ex: 30",
    "save": "Enregistrer",
    "secretKey": "SECRET KEY",
    "yourSecretKey": "Votre secret key",
    "secretKeyNote": "NB: Veuillez copier ce code et le garder pour pouvoir l'utiliser lors de vos intégrations."
  },
  configurations: {
    "addConfig": "Ajouter une configuration",
    "editConfig": "Modifier une configuration",
    "config": "Configuration",
    "category": "Categorie",
    "value": "Valeur",
    "addBulkConfig": "Ajout en masse",
    "addToList": "Ajouter à la liste",
    "pendingList": "Configurations à créer",
    "remove": "Retirer",
    "alert": "Alert",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact",
    "no": "Non",
    "yes": "Oui",
    "configName": "Nom de la configuration",
    "configNamePlaceholder": "ex: PARAM_ENV",
    "valuePlaceholder": "ex: saisissez la val ici",
    "description": "Description",
    "descriptionPlaceholder": "ex: saisissez la description ici",
    "select": "Selectionnez...",
    "provider": "Entreprise",
    "save": "Enregister",
    "edit": "Modifier",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats",
  },
  fees: {
    "addFee": "Ajouter un frais",
    "bulkFees": "Frais de masse",
    "code": "Code",
    "organization": "Organisation",
    "country": "Pays",
    "operator": "Opérateur",
    "name": "Nom",
    "value": "Valeur",
    "mode": "Mode",
    "feeType": "Type frais",
    "status": "Status",
    "active": "Actif",
    "inactive": "Inactif",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "select": "Selectionnez...",
    "percent": "Pourcentage",
    "valueType": "Valeur",
    "operatorCollectFee": "FRAIS DE COLLECTE OPERATEUR",
    "iMoneyCollectFee": "FRAIS I-MONEY COLLECTE",
    "operatorPayoutFee": "FRAIS DE PAYOUT OPERATEUR",
    "iMoneyPayoutFee": "FRAIS I-MONEY PAYOUT",
    "bankRepayment": "REVERSEMENT SUR COMPTE BANCAIRE",
    "cryptoRepayment": "REVERSEMENT SUR COMPTE DE CRYPTOMONNAIE",
    "topup": "RECHARGEMENT",
    "fee": "Frais",
    "namePlaceholder": "taux de ...",
    "valuePlaceholder": "2",
    "operators": "Opérateurs",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  users: {
    "createUser": "Créer un utilisateur",
    "id": "ID",
    "name": "NOM",
    "organization":"ORGANISATION",
    "username": "NOM UTILISATEUR",
    "email": "E-MAIL",
    "role": "ROLE",
    "search": "Rechercher...",
    "showing": "Affichage de",
    "outOf": "sur",
    "results": "résultats",
    "type": "TYPE",
    "status": "STATUT",
    "validator": "VALIDATEUR",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "yes": "OUI",
    "no": "NON",
    "generatePassword": "Générer mot de passe",
    "generatedPassword": "Mot de passe généré",
    "edit": "Modifier",
    "activateValidator": "Activer validateur",
    "deactivateValidator": "Désactiver validateur",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "permission": "Permission",
    "permissionManagement": "Gestion des permissions",
    "list": "Liste",
    "assign": "Attribuer",
    "restore": "Restaurer",
    "code": "CODE",
    "availablePermissions": "Permissions disponibles",
    "revoke": "Revoquer",
    "revokeReason": "Motif de revocation...",
    "create": "Création",
    "user": "d'un utilisateur",
    "fullName": "Nom complet",
    "fullNamePlaceholder": "Ex: Ouattara Patrick",
    "emailPlaceholder": "Ex: info chez imoney point africa",
    "select": "Selectionnez...",
    "password": "Mot de passe",
    "confirmPassword": "Confirmation du mot de passe",
    "copyPaste": "Copier/Coller",
    "save": "Enregister",
    "previous": "Précédent",
    "next": "Suivant",
    "confirmRestore": "Voulez-vous vraiment restaurer la permission ?",
    "organizationCode": "Code organisation"
  },
  accounts: {
    "createAccount": "Créer un compte",
    "createSubAccount": "Créer un sous-compte",
    "id": "ID",
    "name": "NOM",
    "type": "TYPE",
    "attachedTo": "RATTACHÉ À",
    "status": "STATUT",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "createAccountTitle": "Création d'un compte",
    "editAccountTitle": "Modification du compte",
    "accountName": "Nom du compte",
    "accountNamePlaceholder": "ex: Ouattara Patrick",
    "accountType": "Type de compte",
    "users": "Utilisateurs",
    "select": "Selectionnez...",
    "save": "Enregister"
  },
  repayments: {
    "excel": "Excel",
    "createRequest": "Faire une demande de réversement",
    "code": "Code",
    "organization": "Organisation",
    "type": "Type",
    "initiatedBy": "initié par",
    "validatedBy": "Validé par",
    "amount": "Montant",
    "search": "Rechercher...",
    "showing": "Affichage de",
    "outOf": "sur",
    "results": "résultats",
    "totalFees": "Total frais",
    "status": "Status",
    "pending": "En attente",
    "validated": "Validé",
    "rejected": "Rejeté",
    "reject": "Réjeté",
    "validate": "Validé",
    "bankAccount": "compte bancaire",
    "cryptoAccount": "Compte Cryptomonnaie",
    "payoutAccount": "Compte pay out",
    "repaymentRequest": "Demande de réversement",
    "balance": "SOLDE",
    "repaymentType": "Type de réversement",
    "select": "Selectionnez...",
    "description": "Description",
    "descriptionPlaceholder": "Saisir la description de l'entreprise ici",
    "save": "Enregister",
  },
  reloadings: {
    "excel": "Excel",
    "search": "Rechercher...",
    "createRequest": "Faire un rechargement",
    "code": "Code",
    "organization": "Organisation",
    "description": "Description",
    "amount": "Montant",
    "date": "Date",
    "attachedTo": "RATTACHÉ À",
    "status": "Status",
    "pending": "En attente",
    "validated": "Validé",
    "rejected": "Rejeté",
    "reject": "Réjeté",
    "validate": "Validé",
    "edit": "Modifier",
    "reloadRequest": "Demande de rechargement",
    "balance": "SOLDE",
    "users": "Utilisateurs",
    "select": "Selectionnez...",
    "descriptionPlaceholder": "Saisir la description de l'entreprise ici",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats",
    "details": "Détails",
    "createdBy": "Créé par",
    "validatedBy": "Validé par",
    "name": "Nom",
    "notValidatedYet": "Pas encore validé",
    "close": "Fermer"
  },
  business: {
    "addBusiness": "Ajouter un business",
    "editBusiness": "Modifier un business",
    "code": "Code",
    "organization": "Organisation",
    "name": "Nom",
    "search": "Rechercher...",
    "description": "Description",
    "maxAmount": "Montant maximum",
    "validation": "Validation",
    "collectBalance": "Solde collecte",
    "transferBalance": "Solde transfert",
    "yes": "OUI",
    "no": "NON",
    "delete": "Supprimer",
    "edit": "Modifier",
    "alert": "Alert",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact",
    "businessName": "Nom du business",
    "businessNamePlaceholder": "ex: I-MONEY",
    "descriptionPlaceholder": "ex: saisissez la description ici",
    "maxAmountPlaceholder": "ex: 2 000 000",
    "requiresValidation": "Nécessite une validation",
    "category": "Catégorie",
    "selectCategory": "Selectionnez une catégorie",
    "save": "Enregister",
    "showing": "Showing",
    "outOf": "out of",
    "results": "resultats"
  },
  validationform: {
    "passwordRequired": "Le mot de passe est requis",
    "passwordMinLength5": "Le mot de passe doit faire au moins 5 caractères",
    "emailValid": "l'e-mail doit être un e-mail valide",
    "emailRequired": "L'email est requis",
    "typeRequired": "Le type de compte est requis",
    "typeInvalid": "Le type de compte doit être WEB ou API",
    "passwordMinLength6": "Le mot de passe doit faire au moins 6 caractères",
    "confirmPasswordRequired": "La confirmation du mot de passe est requise",
    "confirmPasswordMinLength6": "Le mot de passe doit faire au moins 6 caractères",
    "passwordMustMatch": "La confirmation du mot de passe doit être identique au mot de passe",
    "companyNameRequired": "La raison sociale est requise",
    "nameRequired": "Votre nom est requis",
    "phoneRequired": "Le numéro de téléphone est requis",
    "phoneValid": "Veuillez saisir un numéro de téléphone valide",
    "phoneLength": "Le numéro de téléphone doit faire exactement 10 chiffres",
    "bankNameRequired": "Le nom de la banque est requis",
    "ribRequired": "Le RIB est requis",
    "registrationSuccess": "Inscription effectuée avec succès nous vous contacterons pour la validation de votre compte"
  },
  settings: {
    personalInfo: "Informations personnelles",
    changePassword: "Modifier mon mot de passe",
    organizationName: "Nom de l'organisation",
    firstName: "Nom",
    lastName: "Prénom(s)",
    email: "Email",
    language: "Langue",
    "changeMyPassword": "Modifier mon mot de passe",
    "oldPassword": "Ancien mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmation du nouveau mot de passe",
    "changePasswordBtn": "Changer le mot de passe",
    "oldPasswordRequired": "Le mot de passe est requis",
    "passwordRequired": "Le mot de passe est requis",
    "confirmPasswordRequired": "Le mot de passe est requis",
    "passwordMinLength": "Le mot de passe doit faire au moins 6 caractères",
    "confirmPasswordMinLength": "Le mot de passe doit faire au moins 6 caractères",
    "passwordMustMatch": "La confirmation du mot de passe doit être identique au mot de passe",
    "editOrganization": "Modifier mon organisation",
    "contact": "Contact",
    "status": "Statut",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "description": "Description",
    "bankDomiciliation": "Domiciliation bancaire",
    "rib": "RIB",
    "cryptoAccount": "Compte crypto",
    "saveChanges": "Enregistrer les modifications",
    "organizationNameRequired": "Le nom de l'organisation est requis",
    "emailRequired": "L'email est requis",
    "emailInvalid": "L'email n'est pas valide",
    "contactRequired": "Le contact est requis",
    "statusRequired": "Le statut est requis",
    "organizationNotFound": "Organisation introuvable",
    "organizationUpdated": "Organisation mise à jour avec succès",
    "organizationCode": "Code de l'organisation",
    "organizationType": "Type d'organisation",
    "representativeName": "Nom du représentant",
    "representativeIdDocs": "Pièce d'identité du représentant",
    "headOfficeAddress": "Adresse du siège social",
    "maxPayoutAmount": "Montant maximum de paiement",
    "payoutValidationDelay": "Délai de validation des paiements",
    "validatePayoutBeforProcess": "Valider les paiements avant traitement",
    "isTestOrganization": "Organisation de test",
    "createdAt": "Créée le",
    "updatedAt": "Modifiée le"
  }
}
